// Tiny key-value store. Uses Capacitor Preferences on native, localStorage on web.
// Async-only API so callers don't have to branch.
import { Preferences } from "@capacitor/preferences";
import { isNative } from "./platform";

export const kv = {
  async get(key: string): Promise<string | null> {
    if (isNative()) {
      const { value } = await Preferences.get({ key });
      return value ?? null;
    }
    try { return localStorage.getItem(key); } catch { return null; }
  },
  async set(key: string, value: string): Promise<void> {
    if (isNative()) { await Preferences.set({ key, value }); return; }
    try { localStorage.setItem(key, value); } catch {}
  },
  async remove(key: string): Promise<void> {
    if (isNative()) { await Preferences.remove({ key }); return; }
    try { localStorage.removeItem(key); } catch {}
  },
};
